<template>
  <div class="coupon-list-n">
    <slot></slot>
    <div class="coupon-content-n">
      <div
        v-for="(item, index) in couponList"
        :key="index"
        v-auth:click="{ method: clickCoupon, params: { coupon: item } }"
        :class="['coupon-list__item', { active: item.is_client }]"
      >
        <div class="coupon-list__left">
          <img :src="item.brand_logo" alt class="logo" />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
      <div v-show="couponMetal.total === 0" class="no-coupon">优惠券已派完</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    couponList: {
      type: Array,
      default() {
        return [];
      },
    },
    couponMetal: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    clickCoupon(item) {
      this.$emit('clickCoupon', item);
    },
  },
};
</script>

<style lang="scss" scoped>
//优惠券样式
$couponWidth: 667px;
$couponHeight: 171px;
$couponBg: url(~@this/assets/coupon2.png) center/contain no-repeat;
$couponActiveBg: url(~@this/assets/coupon2-1.png) center/contain no-repeat;
$couponTitleWidth: 320px;
.coupon-list-n {
  position: relative;
  .coupon-content-n {
    width: $couponWidth;
    margin: 0 auto;
    .coupon-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      &__item {
        width: $couponWidth;
        height: $couponHeight;
        position: relative;
        background: $couponBg;
        display: flex;
        color: #383838;
        &.active {
          background: $couponActiveBg;
          .title {
            color: #999;
          }
        }
      }
      &__left {
        flex: 1;
        display: flex;
        align-items: center;
        height: $couponHeight;
        .logo {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          margin-left: 30px;
          margin-right: 20px;
          margin-top: -10px;
        }
        .title {
          font-size: 30px;
          width: $couponTitleWidth;
          color: #1079f3;
          line-height: 1.2;
          margin-top: -10px;
        }
      }
    }
  }
  .no-coupon {
    padding: 40px 0;
    text-align: center;
    color: #ffffff;
  }
}
</style>
